<template>
  <div>
    <h1>Lo sentimos, ocurrió un error</h1>
    <p>Estaremos de vuelta lo más pronto posible</p>
    <hr>
  </div>
</template>

<script>
export default {
  name: "ErrorView"
}
</script>

<style scoped>

</style>
